query GetImport2CrmOptions {
    import2CrmOptions {
        type
        label
    }
}
